import './src/styles/global.css'
import './src/styles/font.css'
import './src/styles/prism-heighlight.css'
require("prismjs/themes/prism.css")
require(`katex/dist/katex.min.css`)

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
